import { apiPaths, queryKeyWithNpsn } from 'api/kinerja/kepala-sekolah/config'
import { useMutationApi, useQueryApi } from 'utils/api'

import type { TPayloadAtasan, TResponseAtasan } from 'types/kinerja-atasan'
import type { PelaksanaanError } from 'types/kinerja-ks-pelaksanaan'
import type { UseMutationOptions, UseQueryOptions } from 'react-query'

export const API_GET_DIRECT_REPORTS = 'API_GET_DIRECT_REPORTS'

export function useApiGetAtasan(
  npsn: string,
  opts?: UseQueryOptions<TResponseAtasan>
) {
  return useQueryApi<TResponseAtasan>(apiPaths.atasan, {
    axiosConfig: {
      params: {
        npsn,
      },
    },
    queryConfig: {
      useErrorBoundary: false,
      ...opts,
    },
    queryKey: queryKeyWithNpsn(API_GET_DIRECT_REPORTS, npsn),
  })
}

export function useApiPostAtasan(
  opts?: UseMutationOptions<any, PelaksanaanError, TPayloadAtasan>
) {
  return useMutationApi(`${apiPaths.atasan}/confirm`, {
    axiosConfig: {
      method: 'POST',
    },
    mutationConfig: {
      useErrorBoundary: false,
      ...opts,
    },
  })
}
